import { createAction } from "typesafe-actions";
import { domain } from "./type.js";
const actions = {
  cancelRequests: createAction(`${domain}/cancelRequests`)(),
  redirectStepUp: createAction(`${domain}/redirectStepUp`)()
};
export {
  actions
};
//# sourceMappingURL=action.js.map
